import ChatHistory from "./ChatHistory";
import { Box, Stack } from "@mui/material";
import axios from "axios";
import Cookies from "js-cookie";
import { useCallback, useEffect, useState } from "react";
import NotAuthorized from "../NotAuthorized";
import PlanForm from "../Planform";
import AdminMenu from "./AdminMenu";
import ChangePrivacy from "./ChangePrivacy";
import CreateArticles from "./CreateArticles";
import CreateNews from "./CreateNews";
import ShowData from "./ShowData";
import ChangeShow from "./ChangeShow";
import SendNoti from "./SendNoti";
import SearchBar from "./SearchBar";
import NotificationForm from "./NotificationForm";
import AnalyticsDashboard from "./AnalyticsDashboard";

const TABLE_ENDPOINTS = {
  approved: "allbids",
  unapproved: "allunbids",
  users: "allusers",
  subs: "allsubs",
  admins: "alladmins",
  history: "allhistory",
  deals: "alldeals",
};

function AdminHome() {
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [what, setWhat] = useState("unapproved");
  const [show, setShow] = useState(false);

  useEffect(() => {
    const endpoint = TABLE_ENDPOINTS[what];

    // Non-table tools (articles, settings, notifications, etc.) must not call /api/admin/.
    if (!endpoint) {
      setShow(false);
      setData([]);
      setOriginalData([]);
      return;
    }

    let active = true;
    setShow(false);

    axios
      .get(`${process.env.React_APP_BACKEND_URL}/api/admin/${endpoint}`, {
        headers: { Authorization: `Bearer ${Cookies.get("admintoken")}` },
      })
      .then((response) => {
        if (!active) return;
        const rows = response.data?.Bids || [];
        setOriginalData(rows);
        setData(rows);
        setShow(true);
      })
      .catch((error) => {
        if (active) console.error(error);
      });

    return () => {
      active = false;
    };
  }, [what]);

  const deepContains = (value, query) => {
    if (value == null) return false;
    if (["string", "number", "boolean"].includes(typeof value)) {
      return String(value).toLowerCase().includes(query);
    }
    if (Array.isArray(value)) return value.some((item) => deepContains(item, query));
    if (typeof value === "object") {
      return Object.values(value).some((item) => deepContains(item, query));
    }
    return false;
  };

  const handleSearch = useCallback(
    (term) => {
      const query = term.trim().toLowerCase();
      setData(query ? originalData.filter((row) => deepContains(row, query)) : originalData);
    },
    [originalData]
  );

  const isTableSection = Boolean(TABLE_ENDPOINTS[what]);

  return (
    <Box sx={{ fontFamily: "Assistant", mt: "20px" }}>
      {(Cookies.get("adminId") === null || Cookies.get("adminId") === undefined) && (
        <NotAuthorized />
      )}

      <Stack
        sx={{ fontFamily: "Assistant", px: 2 }}
        className="App"
        spacing={2}
        direction="row"
        justifyContent="space-evenly"
        alignItems="center"
      >
        <AdminMenu setWhat={setWhat} setShow={setShow} />
        {isTableSection && (
          <Box sx={{ width: 300 }}>
            <SearchBar onSearch={handleSearch} />
          </Box>
        )}
      </Stack>

      {show && isTableSection && (
        <ShowData data={data} what={what} sx={{ marginRight: "10px" }} setWhat={setWhat} />
      )}

      {what.toString().includes("sendNotiToUser") && <NotificationForm type={what.toString()} />}
      {what === "sendNoti" && <SendNoti />}
      {what === "sendNotiClients" && <NotificationForm type={what} />}
      {what === "sendNotiPro" && <NotificationForm type={what} />}
      {what === "changeShow" && <ChangeShow />}
      {what === "createArticles" && <CreateArticles />}
      {what === "createans" && <PlanForm />}
      {what === "createNews" && <CreateNews />}
      {what === "chatHistory" && <ChatHistory />}
      {what === "analytics" && <AnalyticsDashboard />}
      {what === "changePrivacy" && <ChangePrivacy change="privacy" />}
      {what === "changeAboutUs" && <ChangePrivacy change="aboutus" />}
      {what === "faq" && <ChangePrivacy change="faq" />}
      {what === "termsofuse" && <ChangePrivacy change="termsofuse" />}
      {what === "support" && <ChangePrivacy change="support" />}
      {what === "changelink" && <ChangePrivacy change="changelink" />}
    </Box>
  );
}

export default AdminHome;
